import "~/misc/common";
import { loader } from "~/misc/common";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    console.log('initImportFile');

    const fileInput = $("#file_uri");
    const dropZone = fileInput.closest(".drop-zone");

    $("#file_uri").on('change', function () {
      submitForm();
    });

    // ✅ Drag over highlight
    dropZone.on("dragover", function (e) {
      e.preventDefault();
      e.stopPropagation();
      dropZone.addClass("drag-over");
    });

    // ✅ Drag leave reset
    dropZone.on("dragleave", function (e) {
      e.preventDefault();
      e.stopPropagation();
      dropZone.removeClass("drag-over");
    });

    // ✅ Drop file
    dropZone.on("drop", function (e) {
      e.preventDefault();
      e.stopPropagation();

      dropZone.removeClass("drag-over");

      const event = e.originalEvent;
      if (!event || !event.dataTransfer) return;

      const files = event.dataTransfer.files;
      if (!files || files.length === 0) return;

      // Assign dropped file(s)
      const inputEl = fileInput[0] as HTMLInputElement;
      inputEl.files = files;

      // Auto-submit
      submitForm();
    });

    function submitForm() {
      loader(true);
      $('form.file').trigger('submit');
    }
  }
}